import React, { useEffect, useState } from 'react';

export default function SalesCenter() {
  const [loading, setLoading] = useState(true);
  const [exists, setExists] = useState(false);
  const [data, setData] = useState(null);
  const [devMode, setDevMode] = useState(false);
  const [rawJson, setRawJson] = useState(null);
  const [normalized, setNormalized] = useState(null);
  const [html, setHtml] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    async function fetchLast() {
      setLoading(true);
      setError(null);
      const envHost = (import.meta?.env?.VITE_API_HOST) || null;
      const defaultHost = `${window.location.hostname}:5050`;
      const apiHost = envHost || defaultHost;

      const preferProto = window.location.protocol === 'https:' ? 'https:' : 'http:';

      let url = `${preferProto}//${apiHost}/api/transport-normalized`;

      try {
        let res;
        try {
          res = await fetch(url);
        } catch (innerErr) {
          if (url.startsWith('https:')) {
            url = `http://${apiHost}/api/transport-normalized`;
            res = await fetch(url);
          } else {
            throw innerErr;
          }
        }

        const json = await res.json();
        if (!mounted) return;
        setExists(Boolean(json.exists));
        setData(json || null);
        setRawJson(json.raw || null);
        setNormalized(json.normalized || null);
        setHtml(json.html || null);
      } catch (err) {
        if (!mounted) return;
        setError(String(err));
      } finally {
        if (mounted) setLoading(false);
      }
    }
    fetchLast();
    return () => { mounted = false; };
  }, []);

  return (
    <div className="min-h-screen p-6 surface">
      <h2 className="text-2xl text-ice font-semibold mb-4">Sales Center</h2>

      {loading && <div className="text-mist">Loading...</div>}

      {!loading && error && (
        <div className="p-4 rounded bg-red-900 text-red-300">Error: {String(error)}</div>
      )}

      {!loading && !error && !exists && (
        <div className="p-4 rounded bg-yellow-900 text-yellow-300">No transport payload saved</div>
      )}

      {!loading && !error && exists && (
        <div>
              <div className="mb-3 text-green-300">Latest transport payload:</div>

              <button
                onClick={() => setDevMode(v => !v)}
                className="bg-gray-700 hover:bg-gray-600 text-white px-3 py-1 rounded mb-4"
              >
                {devMode ? "Hide Developer Fields" : "Show Developer Fields"}
              </button>

              {devMode && (
                <>
                  <h3 className="text-xl text-green-400 mt-6">Raw JSON:</h3>
                  <pre className="p-4 rounded bg-gray-900 text-green-300 text-sm overflow-auto">
                    {JSON.stringify(data?.raw || rawJson || {}, null, 2)}
                  </pre>

                  <h3 className="text-xl text-blue-400 mt-6">Normalized JSON:</h3>
                  <pre className="p-4 rounded bg-gray-900 text-blue-300 text-sm overflow-auto">
                    {JSON.stringify(data?.normalized || normalized || {}, null, 2)}
                  </pre>
                </>
              )}

              <h3 className="text-xl text-yellow-400 mt-6">HTML view:</h3>
              <div
                className="p-4 rounded bg-black text-white text-sm leading-relaxed"
                dangerouslySetInnerHTML={{ __html: (data && data.html) || html || '<i>No summary available</i>' }}
              ></div>
        </div>
      )}
    </div>
  );
}

